import { useTranslation } from 'react-i18next';
import ThemeToggle from './ThemeToggle';
import LanguageSwitcher from './LanguageSwitcher';
import AppStoreBadges from './AppStoreBadges';
import ResponsiveImage from './ResponsiveImage';

export default function Header({ theme, onToggleTheme }) {
  const { t } = useTranslation();
  
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 dark:bg-slate-900/80 backdrop-blur-md border-b border-slate-200 dark:border-slate-700 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3">
            <img 
              src="/apple-touch-icon.png" 
              alt={t('header.logoAlt')}
              className="w-10 h-10 rounded-xl shadow-md"
              width={40}
              height={40}
              loading="eager"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-sky-600 to-blue-600 dark:from-sky-400 dark:to-blue-400 bg-clip-text text-transparent">
              {t('header.appName')}
            </span>
          </div>
          
          <nav className="hidden md:flex items-center gap-8">
            <a href="#how-it-works" className="text-slate-700 dark:text-slate-300 hover:text-sky-700 dark:hover:text-sky-300 font-medium transition-colors">
              {t('header.howItWorks')}
            </a>
            <a href="#features" className="text-slate-700 dark:text-slate-300 hover:text-sky-700 dark:hover:text-sky-300 font-medium transition-colors">
              {t('header.features')}
            </a>
            <a href="#faq" className="text-slate-700 dark:text-slate-300 hover:text-sky-700 dark:hover:text-sky-300 font-medium transition-colors">
              {t('header.faq')}
            </a>
            <a href="#changelog" className="text-slate-700 dark:text-slate-300 hover:text-sky-700 dark:hover:text-sky-300 font-medium transition-colors">
              {t('header.changelog')}
            </a>
          </nav>
          
          <div className="flex items-center gap-3">
            {/* <LanguageSwitcher /> */}
            <ThemeToggle theme={theme} onToggle={onToggleTheme} />
          </div>
        </div>
      </div>
    </header>
  );
}
